module.exports = __webpack_public_path__ + "static/moultriehh-29bbe6abab2710e4862931da2613f9b7.jpg";